import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-emerald-950 text-white" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <span className="font-outfit font-black text-white text-2xl tracking-tighter">
              4L<span className="text-emerald-400">.</span>
            </span>
            <p className="font-outfit text-lg font-semibold text-white mt-1">4 Longevity</p>
            <p className="text-emerald-200/70 text-sm mt-3 leading-relaxed">
              Sustainable Growth for Your Real Estate Portfolio.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-outfit font-semibold text-white text-sm uppercase tracking-wider mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><a href="/#services" className="text-emerald-200/70 hover:text-white text-sm transition-colors">Services</a></li>
              <li><a href="/#calculators" className="text-emerald-200/70 hover:text-white text-sm transition-colors">Calculators</a></li>
              <li><Link to="/quote" className="text-emerald-200/70 hover:text-white text-sm transition-colors">Get a Quote</Link></li>
              <li><a href="/#faq" className="text-emerald-200/70 hover:text-white text-sm transition-colors">FAQ</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-outfit font-semibold text-white text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-3">
              <li><span className="text-emerald-200/70 text-sm">Property Management</span></li>
              <li><span className="text-emerald-200/70 text-sm">Buy & Sell Properties</span></li>
              <li><span className="text-emerald-200/70 text-sm">Investment Consulting</span></li>
              <li><span className="text-emerald-200/70 text-sm">Tenant Screening</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-outfit font-semibold text-white text-sm uppercase tracking-wider mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <a href="tel:1-888-419-9767" className="text-emerald-200/70 hover:text-white text-sm transition-colors">1-888-419-9767</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <a href="mailto:general@4longevity.live" className="text-emerald-200/70 hover:text-white text-sm transition-colors">general@4longevity.live</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <a href="mailto:quotes@4longevity.live" className="text-emerald-200/70 hover:text-white text-sm transition-colors">quotes@4longevity.live</a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-emerald-400 flex-shrink-0" />
                <a href="mailto:admin@4longevity.live" className="text-emerald-200/70 hover:text-white text-sm transition-colors">admin@4longevity.live</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-emerald-800/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-emerald-200/50 text-xs">&copy; {new Date().getFullYear()} 4 Longevity. All rights reserved.</p>
          <p className="text-emerald-200/50 text-xs">4longevity.live</p>
        </div>
      </div>
    </footer>
  );
}
